// Shared BaseUI Drawer override styles.
//
// BaseUI's StyledDrawerBody sets LONGHAND margins (marginTop/Right/Bottom/Left:
// scale900 = 32px). A shorthand `margin: 0` override does not reliably beat
// longhands in Styletron's atomic CSS, so the body ends up 100% tall PLUS 64px
// of margins and pinned footers get pushed below the viewport (SAM-167).
// Always reset with longhands.
export const DRAWER_BODY_RESET = {
  marginTop: 0,
  marginRight: 0,
  marginBottom: 0,
  marginLeft: 0,
  paddingTop: 0,
  paddingRight: 0,
  paddingBottom: 0,
  paddingLeft: 0,
} as const;
